module.exports = __webpack_public_path__ + "static/media/ProductImagePlaceholder.4c29ddd6.png";